import React from "react";

export default function SourseCode() {
  return (
    <div className="openSourseLink mt-5 pt-5">
      Coded by {""}
      <a href="https://precious-nougat-dc3972.netlify.app/">Olesia</a> and is{" "}
      {""}
      <a href="https://github.com/OlesiaShev/Dark-Weather-App">
        open source code 2022
      </a>
    </div>
  );
}
